import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';
import Modal from '../Modal';
import Button from '../Button';

export default function ModalDownloadOutOfRange({ open, onClose, range }) {
  return (
    <Modal className={styles.modal} onClose={onClose} open={open}>
      <div className={styles['modal-header']}>
        <h3>Unduh Data Gagal</h3>
        <p>
          Anda memilih range tanggal lebih dari {range} hari, ubah range tanggal
          maksimal {range} hari untuk unduh data.
        </p>
      </div>
      <div className={styles['modal-body']}>
        <Button onClick={onClose} style={'blue'}>
          Ok
        </Button>
      </div>
    </Modal>
  );
}

ModalDownloadOutOfRange.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  range: PropTypes.string,
};
